import React from "react";

export const Loading = (props) => {
    return (
        <div className="d-flex justify-content-center align-items-center w-100 h-100">
            <div className="loading"/>
        </div>

    );
};
